<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="flex flex-col justify-center items-start grid-toolbar-buttons-group-container w-p-100">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs" iconClass="fas fa-calendar-week"></particle-breadcrumbs>
    </div>
    <div class="toggle-buttons-view flex flex-col justify-end items-start">

      <mat-button-toggle-group #group="matButtonToggleGroup" class="view-change-toggle-container m-t-10">
        <mat-button-toggle value="left" [routerLink]="'/task-manager/card'">
          <i class="far fa-columns"></i>
        </mat-button-toggle>
        <mat-button-toggle value="center" [routerLink]="'/task-manager/grid'">
          <i class="far fa-th active"></i>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">

        <div class="content pos-relative m-30 flex flex-col">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceKey"
                                   sortFieldKey="Name"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
                                   [useSwitchMap]="1===1"
                                   tag="BoardList"
            >
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
    <!-- / CENTER -->
  </mat-sidenav-container>
</div>
